export class ResponseData {

	public  responsedata: any;
	public  headers: any;
    public  buttons: any;
    public  totals: any;
    public  showHideTds: boolean[];
    constructor()
    {
       this.headers = null;
       this.responsedata=null;
       this.buttons=null;
       this.totals=null;
       this.showHideTds=null;
    }
}